var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchIcon = function SvgSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BEBEBE",
    fillRule: "evenodd",
    d: "M10.145 11.646a5.837 5.837 0 1 1 1.5-1.5L15 13.498 13.5 15zM6.837 10.55a3.714 3.714 0 1 0 0-7.429 3.714 3.714 0 0 0 0 7.429"
  })));
};
export default SvgSearchIcon;